<template>
    <div :class="['completed-filter', { hidden: filtersHidden }]">
        <div class="completed-filter__selects-container -wrap" >
            <div class="completed-filter__selects">
                <!-- <CategoriesFilter ref="categories" :entityList="[...completedCourses, ...completedLearningPaths]" /> -->
                <CompletedLevelFilter ref="level" :entityList="[...completedCourses, ...completedLearningPaths]" />
                <InstructorFilter ref="instructor" :courseList="completedCourses" />
                <AuthorizationFilter ref="authorization" :courseList="completedCourses" />
                <TotemToggleButton
                    v-model="showExpiredCourses"
                    :value="showExpiredCourses"
                    :label="$t('CourseListFilter.show_expired_courses')"
                    class="filter-select"
                />
            </div>
        </div>
        <CompletedTags v-on:removeTag="removeTag" />
        <div class="completed-filter__search">
            <TotemSearch class="completed-filter__search-input" v-model="search" v-on:clearSearch="onClearSearch"/>
            <div class="completed-filter__dates">
                <span class="completed-filter__dates-label" v-html="$t('CompletedFilter.filter_by_date')"></span>
                <TotemDatepicker :placeholder="$t('General.start_date')" v-model="startDate" />-
                <TotemDatepicker :placeholder="$t('General.end_date')" v-model="endDate" />
            </div>
            <div class="clear-filters">
                <a
                    href="#"
                    @click="removeAllTags"
                    class="clear-filters__link"
                    v-html="$t('CourseListFilter.clear_all_filters')"
                >
                </a>
            </div>
        </div>
        <TotemToast ref="toast" :top="10" />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import moment from 'moment'
    import CategoriesFilter from 'components/user/items-listings/filters/CategoriesFilter'
    import CompletedLevelFilter from 'components/user/items-listings/filters/CompletedLevelFilter'
    import InstructorFilter from 'components/user/items-listings/filters/InstructorFilter'
    import AuthorizationFilter from 'components/user/items-listings/filters/AuthorizationFilter'
    import CompletedTags from './CompletedTags'
    import expiredCoursesAndCollections from 'components/shared/mixins/expiredCoursesAndCollections'

    export default {
        props: {
            completedCourses: Array,
            completedLearningPaths: Array,
            sorting: {
                type: Function,
                default: () => (el) => el
            },
            learningPathSorting: {
                type: Function,
                default: () => (el) => el
            },
            filtersHidden: {
                type: Boolean,
                default: false
            }
        },
        components: {
            CategoriesFilter,
            CompletedLevelFilter,
            InstructorFilter,
            AuthorizationFilter,
            CompletedTags
        },
        mixins: [ expiredCoursesAndCollections ],
        data () {
            return {
                endDate: '',
                startDate: '',
                filterCategories: [],
                search: '',
                filteredData: [],
                showExpiredCourses: true
            }
        },
        computed: {
            ...mapGetters({
                selectedOptions: 'CourseFilter/getSelectedCategories',
                categories: 'CourseFilter/getCategories',
                selectedLevel: 'CourseFilter/getSelectedLevel',
                selectedInstructor: 'CourseFilter/getSelectedInstructor',
                selectedAuthorization: 'CourseFilter/getSelectedAuthorization'
            }),
            compoundProperty () {
                this.search
                this.selectedOptions
                this.selectedLevel
                this.startDate
                this.endDate
                this.sorting
                this.learningPathSorting
                this.selectedInstructor
                this.selectedAuthorization
                this.showExpiredCourses
                return Date.now()
            },
            formattedStartDate () {
                if (this.startDate === '') {
                    return null
                } else {
                    return this.formatDateInput(this.startDate)
                }
            },
            formattedEndDate () {
                if (this.endDate === '') {
                    return null
                } else {
                    return this.formatDateInput(this.endDate)
                }
            }
        },
        methods: {
            filter () {
                let filters = [
                    this.filterBySearch,
                    // this.$refs.categories.filterByCategories,
                    this.filterByDaterange,
                    this.$refs.level.filterByLevel,
                    this.$refs.instructor.filterByInstructor,
                    this.$refs.authorization.filterByAuthorization,
                    this.toggleExpiredCourses
                ]
                let filteredCourses = filters.reduce((acc, filter, index) => {
                    if (filter === null) {
                        return acc
                    }
                    return filter(acc)
                }, this.completedCourses)

                let filteredLearningPaths = filters.reduce((acc, filter, index) => {
                    if (filter === null) {
                        return acc
                    }
                    return filter(acc)
                }, this.completedLearningPaths)

                if (this.sorting) {
                    filteredCourses = this.sorting(filteredCourses)
                }

                if (this.learningPathSorting) {
                    filteredLearningPaths = this.learningPathSorting(filteredLearningPaths)
                }
                this.filteredData = filteredCourses
                this.$emit('completed-courses-filtered', filteredCourses, filteredLearningPaths)
            },
            filterBySearch (data) {
                if (this.search === '') {
                    return data
                }
                return data.filter(course => course.title.toLowerCase().search(this.search.toLowerCase()) !== -1)
            },
            filterByDaterange (data) {
                if ((this.formattedStartDate && this.formattedStartDate.length > 9) && (this.formattedEndDate && this.formattedEndDate.length > 9)) {
                    let startDate = moment(this.formattedStartDate, 'DD.MM.YYYY').toDate()
                    let endDate = moment(this.formattedEndDate, 'DD.MM.YYYY').toDate()
                    return data.filter(course => {
                        const certificateCreationDate = new Date(course.certificate.date)
                        return certificateCreationDate >= startDate && certificateCreationDate <= endDate
                    })
                } else {
                    return data
                }
            },
            toggleExpiredCourses (data) {
                if (this.showExpiredCourses) {
                    return data
                }
                return data.filter(course => {
                    return !course.isExpired
                })
            },
            removeAllTags () {
                this.$refs.level.clear()
                this.$refs.instructor.clear()
                this.$refs.authorization.clear()
                this.$store.dispatch('CourseFilter/removeAllCategoriesOptions')
                this.endDate = ''
                this.startDate = ''
                this.search = ''
                this.$emit('clear-filters')
                this.$refs.toast.show(this.$t('CourseListFilter.clear_search_notification'))
            },
            removeTag (tag) {
                this.$refs[tag].clear()
            },
            formatDateInput (date) {
                return moment(date).format('DD.MM.YYYY')
            },
            onClearSearch () {
                this.search = ''
            }
        },
        watch: {
            completedCourses: {
                handler: 'filter'
            },
            completedLearningPaths: {
                handler: 'filter'
            },
            compoundProperty: {
                handler: 'filter'
            }
        },
        created () {
            this.$store.dispatch('CourseFilter/loadCategories')
            if (this.$route.params.startDate !== undefined && this.$route.params.endDate !== undefined) {
                this.startDate = this.$route.params.startDate
                this.endDate = this.$route.params.endDate
            }
        },
        beforeDestroy () {
            this.$store.dispatch('CourseFilter/clearFilter')
        }
    }

</script>

<style lang="scss" scoped>
    .completed-filter {
        border: 1px solid $quill_gray;
        background: $alabaster;
        padding: 15px 20px 15px;
        margin: 0 0 20px;
        position: relative;

        &.hidden {
            display: none;
        }

        &__selects-container {
            padding: 5px 0;
            display: flex;
            align-items: center;
            flex-direction: column;
            position: relative;

            [class*="desktop"] & {
                flex-direction: row;
                justify-content: space-between;
                align-items: flex-start;
            }
        }

        &__selects {
            display: flex;
            flex-direction: row;
            flex: 1;
            flex-wrap: wrap;
            justify-content: center;

            [class*="desktop"] & {
                justify-content: flex-start;
            }
        }

        &__select {
            margin: 0 5px 10px;
        }

        &__search {
            display: flex;
            flex-direction: column;
            align-items: center;

            [class*="desktop_x"] & {
                flex-direction: row;
            }
        }

        &__search-input {
            align-self: flex-start;
            margin: 0 10px 0 0;
        }

        &__dates {
            display: flex;
            flex-direction: column;
            line-height: 30px;

            [class*="desktop"] & {
                flex-direction: row;
                align-items: center;
            }
        }

        &__dates-label {
            font-size: 1.4rem;
            font-family: Nunito-Bold, sans-serif;
            padding: 0 0 10px 0;

            [class*="desktop"] & {
                padding: 0 10px 0 0;
            }
        }

        .clear-filters {
            @include clear-filters;
            [class*="mobile"] & {
                margin: 30px 0;
            }
        }
    }
</style>
